<button (click)="uploader.click()"
  [disabled]="isDisabled"
  class="btn btn-outline-primary"
  [title]="title"
  type="button">
  <span>
    <span class="fa-solid fa-upload"></span>
    @if (label) {
      <span [innerText]="label"></span>
    }
  </span>
  <input #uploader
    (change)="onFileSelected($event)"
    [hidden]="true"
    [accept]="fileExtensions"
    class="hidden-file-upload"
    type="file"/>
  </button>